<div class="ms-3" [innerHTML]="message.text"></div>
